import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export interface ImagePreviewDialogData {
  /** Object URL ya cargado (el padre gestiona su ciclo de vida). */
  imageUrl: string;
  fileName: string;
}

/** Lightbox simple para previsualizar una imagen adjunta a tamaño completo. */
@Component({
  selector: 'app-image-preview-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  template: `
    <div class="preview-wrap">
      <div class="preview-header">
        <span class="preview-name">{{ data.fileName }}</span>
        <button mat-icon-button mat-dialog-close>
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <img class="preview-img" [src]="data.imageUrl" [alt]="data.fileName">
    </div>
  `,
  styles: [`
    .preview-wrap {
      display: flex;
      flex-direction: column;
      max-width: 88vw;
      max-height: 88vh;
    }
    .preview-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      padding: 8px 8px 8px 16px;
    }
    .preview-name {
      font-size: 0.85rem;
      font-weight: 600;
      color: var(--gdp-ink, #1b1464);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .preview-img {
      display: block;
      max-width: 88vw;
      max-height: calc(88vh - 56px);
      object-fit: contain;
      background:
        repeating-conic-gradient(#f0f0f3 0% 25%, white 0% 50%) 0 0 / 20px 20px;
    }
  `]
})
export class ImagePreviewDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: ImagePreviewDialogData) {}
}
